










import Vue from 'vue'
import CefTimestamp from '@/classes/CefTimestamp'
  export default Vue.extend({
  name: 'TimestampDisplay',
  props: {
    debugMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {}
  },
  mounted () {
    (() => new CefTimestamp(10, !!this.debugMode))()
  }
})
